// testId suffixes of the multi-select fit elements. Shared by the component
// and the published driver so a rename can't silently break the driver.
export const MORE_VALUES_TEST_ID_SUFFIX = 'more-values';
export const SELECTED_SUMMARY_TEST_ID_SUFFIX = 'selected-summary';
export const SELECTION_DESCRIPTION_TEST_ID_SUFFIX = 'selection-description';

export const testIdSuffixMatcher = (suffix: string) =>
    new RegExp(`-${suffix}$`);
